import styles from '../../styles/admin/List.module.scss'
import { ClassStatusData } from '../../types/lectures'

import ClassStatusListHeader from './ClassStatusListHeader'
import ClassStatusListItem from './ClassStatusListItem'

interface ClassStatusListComponentProps {
  data: ClassStatusData[]
}

const ClassStatusList = ({ data }: ClassStatusListComponentProps) => {
  return (
    <div className={styles.listWrapper} style={{ width: '600px' }}>
      <ClassStatusListHeader />

      {data && data.length > 0 ? (
        data.map((item, index) => (
          <ClassStatusListItem
            key={`level-${item.LEVEL}`}
            level={item.LEVEL}
            classCounts={item.CLASS_COUNT}
            questionCounts={item.QUESTION_COUNT}
          />
        ))
      ) : (
        <div className={styles.empty}>
          <div className={styles.tableCell}>No Data Available.</div>
        </div>
      )}
    </div>
  )
}

export default ClassStatusList
